// extracted by mini-css-extract-plugin
export default {"component":"BlogPost__component-uXFX","header":"BlogPost__header-gr_9","postTitle":"BlogPost__postTitle-eTEt","meta":"BlogPost__meta-Ntd7"};